// src/api/device.js
import request from '@/utils/request'

// 设备列表
export function getDeviceList(params) {
  return request.get('/wms/device/list', { params })
}

// 新增设备
export function createDevice(data) {
  return request.post('/wms/device', data)
}

// 修改设备
export function updateDevice(id, data) {
  return request.put(`/wms/device/${id}`, data)
}

// 删除设备
export function deleteDevice(id) {
  return request.delete(`/wms/device/${id}`)
}